// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../assets/images/preguntas/icon-chevron.svg", import.meta.url);
// Module
var code = `<section class="preguntas"
    id="preguntas">

    <div class="preguntas__container container container--space">

        <div class="preguntas__row row">

            <!-- LEFT -->
            <div class="preguntas__info col-12 col-lg-6">

                <h2 class="preguntas__title"
                    ng-if="\$ctrl.preguntas.title">
                    {{\$ctrl.preguntas.title}}
                </h2>

                <div class="preguntas__description"
                    ng-bind-html="\$ctrl.preguntas.description">
                </div>

                <a class="preguntas__link link-global link-global--semi-block link-global--purple"
                    ng-href="{{\$ctrl.preguntas.link.url}}"
                    target="_blank">
                    {{\$ctrl.preguntas.link.label}}
                </a>

            </div>


            <!-- RIGHT -->
            <div class="preguntas__faq col-12 col-lg-6">

                <article class="preguntas__item"
                    ng-repeat="item in \$ctrl.preguntas.items track by \$index"
                    ng-class="{'is-open': item.open}">

                    <button class="preguntas__question"
                        ng-click="\$ctrl.toggle(item)">

                        <span class="preguntas__question-text">
                            {{item.pregunta}}
                        </span>


                        <img class="preguntas__chevron"
                            src="${___HTML_LOADER_IMPORT_0___}"
                            alt="">

                    </button>

                    <div class="preguntas__answer"
                        ng-if="item.open"
                        ng-bind-html="item.respuesta">
                    </div>

                </article>

            </div>

        </div>

    </div>

</section>`;
// Exports
export default code;